import React from 'react'
import styled from 'styled-components'
import { useSelector, useDispatch } from 'react-redux'
import { FaArrowLeftLong, FaArrowRightLong } from "react-icons/fa6";
import { BsArrowsFullscreen } from "react-icons/bs";
import { Tooltip } from '@mui/material';
import { pBtn } from 'components/main.styled';
import { AiOutlineFullscreenExit } from "react-icons/ai"; 
import { MdOutlineClose } from "react-icons/md";
import { deleteImage, setConfirmDeleteImage } from 'features/images/imagesSlice'
import { AiOutlineDelete } from "react-icons/ai";
import DestructiveConfirmModal from 'components/modals/DestructiveConfirmModal';
import { useTranslation } from 'react-i18next'

export default function Gallery() {
    const { t } = useTranslation('media')
    const dispatch = useDispatch()
    const { imageDeleteStatus, slideShow, currentSlideIndex, confirmDeleteImage } = useSelector((state) => state.images)
    const [ viewFullscreen, setViewFullscreen ] = React.useState(false)
    const { profileChurch } = useSelector((state) => state.profileChurch)

    const handleDelete = () => {
        dispatch(setConfirmDeleteImage(true))
    }

    const confirmDelete = async () => {

        console.log({
            imageId: slideShow[currentSlideIndex]._id,
            imageUrl: slideShow[currentSlideIndex].url,
        })

        const current = slideShow[currentSlideIndex];
        if (!current?._id) return;

        dispatch(deleteImage({
            churchId: profileChurch._id,
            imageId: current._id,
        }))
    };

    return (
        <GalleryModalContainer
            viewFullscreen={viewFullscreen}
            >
            <Tooltip placement="top" title={t('closeGallery')}>
                <CloseBtn onClick={() => dispatch({ type: 'images/setViewGallery', payload: false })}>
                    <MdOutlineClose />
                </CloseBtn>
            </Tooltip>
            
            <GalleryWrapper
                viewFullscreen={viewFullscreen}
                >
                <GalleryControls
                    viewFullscreen={viewFullscreen}
                    >
                    <Tooltip placement="top" title={t('previousImage')}>
                        <SliderButton
                            onClick={() => {
                                if(currentSlideIndex > 0){  
                                    dispatch({ type: 'images/setSlideShowIndex', payload: currentSlideIndex - 1 })
                                }
                            }}
                            >
                            <FaArrowLeftLong />
                        </SliderButton>
                    </Tooltip>
                    <Tooltip placement="top" title={viewFullscreen ? t('exitFullscreen') : t('fullscreen')}>
                        <SliderButton
                            onClick={() => setViewFullscreen(!viewFullscreen)}
                            >
                            {viewFullscreen ? 
                            <AiOutlineFullscreenExit />
                            :
                            <BsArrowsFullscreen style={{ transform: 'rotate(180deg)' }} />
                            }
                        </SliderButton>
                    </Tooltip>      
                        <Tooltip placement="top" title={t('deleteImage')}>
                        <SliderButton
                            onClick={handleDelete}
                            >
                            <AiOutlineDelete /> 
                        </SliderButton>
                    </Tooltip>                
                    <Tooltip placement="top" title={t('nextImage')}>
                    <SliderButton
                        onClick={() => {
                            if(currentSlideIndex < slideShow.length - 1){
                                dispatch({ type: 'images/setSlideShowIndex', payload: currentSlideIndex + 1 })
                            }       
                        }}
                        >
                        <FaArrowRightLong />
                    </SliderButton>
                    </Tooltip>

                </GalleryControls>
                <img 
                    src={slideShow[currentSlideIndex]?.url}
                    alt={t('galleryImage')}
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        borderRadius: '10px',
                    }}
                />
            </GalleryWrapper> 

            <DestructiveConfirmModal
                open={confirmDeleteImage}
                onClose={() => dispatch(setConfirmDeleteImage(false))}
                onConfirm={confirmDelete}
                loading={imageDeleteStatus === 'LOADING'}
                title={t('deleteImageConfirm')}
                description={t('deleteImageDescription')}
                confirmLabel={t('deleteImage')}
            />
        </GalleryModalContainer>
    )
}



const SliderButton = styled(pBtn)`
    background-color: rgba(128, 124, 124, 0.47);
    color: white;
    font-size: 20px;
`

const CloseBtn = styled(SliderButton)`
    position: absolute;
    top: 20px;
    left: 20px;    
    z-index: 10;
`
const GalleryControls = styled.div`
    position: absolute;
    width: 700px;
    display: flex;
    flex-direction: row;
    justify-content: space-between  ;
    gap: 10px;
    top: ${props => props.viewFullscreen ? '10px' : '-50px'};
    left: 50%;
    transform: translateX(-50%);
    z-index: 10;
`

const GalleryWrapper = styled.div`
    position: relative;
    width: ${props => props.viewFullscreen ? '100vw' : '700px'};
    height: ${props => props.viewFullscreen ? '100vh' : '500px'};
    padding: ${props => props.viewFullscreen ? '100px' : '10px'};
    display: flex;
`

const GalleryModalContainer = styled.div`
    width: 100vw;
    height: 100vh;  
    display: flex; 
    align-items: center;
    justify-content: center;
    background-color: ${props => props.viewFullscreen ? 'black' : 'rgba(0, 0, 0, 0.7)'};
    padding: ${props => props.viewFullscreen ? '50px' : '10px'};
`
